import _ from 'lodash';

/**
 * Assigns own and inherited enumerable string keyed properties
 * of source objects to the target object for all target
 * properties that resolve to `undefined` or `null`
 * @param {object} target - destination object
 * @param  {object[]} sources - source objects
 * @returns
 */
const defaults = (target, ...sources) => {
  sources.forEach((source) => {
    _.forOwn(source, (value, key) => {
      if (target[key] === undefined || target[key] === null) {
        target[key] = value;
      }
    });
  });

  return target;
};

export { defaults };
